const es = {
  'page-title': 'Bootcamps de Laboratoria',
  'page-description': `
    Aprende las habilidades del futuro y transforma tu carrera con nuestros
    bootcamps de desarrollo web, diseño UX y análisis de datos.
  `,
  'callout-text': 'Nuestros bootcamps',
  'know-more': 'Conocer más',
  'know-more-link': 'entra aquí',
  'next-bootcamps': 'Próximos <em>bootcamps:</em> ',
  'title': 'Aprende las habilidades del futuro y transforma tu carrera',
  'web-dev-title': '<em>Bootcamp</em> de desarrollo web',
  'web-dev-description': `
    Aprende a construir aplicaciones web dinámicas y adaptables a distintos
    dispositivos, utilizando un lenguaje moderno y versátil, como JavaScript,
    con librerías como React o Angular.
  `,
  'ux-title': '<em>Bootcamp</em> de diseño UX',
  'ux-description': `
    Aprende las bases del diseño centrado en las personas para diseñar
    productos digitales fáciles de usar y que resuelvan necesidades reales de
    los usuarios.
  `,
  'data-title': `<em>Bootcamp</em> de análisis de datos`,
  'data-description': `
    Aprende todos los pasos del análisis de datos, desde la limpieza y la
    preparación hasta la creación de dashboards y la presentación de los
    resultados. También aprende a usar herramientas de IA.
  `,
  'no-available-cohorts': '¡Abriremos postulaciones próximamente!',
};

export default es;
